import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/attestations/')({
    beforeLoad: ({ params }) => {
        throw redirect({ to: '/console/$orgId/attestations/user-attestations', params, replace: true });
    },
});
